/* eslint-disable */
<template lang="pug">
section(class="separable")
  gerar-declaracao-tramite(:numeroProcesso="numeroProcesso", v-if="showModalDeclaracao" @closeModal="() => this.showModalDeclaracao = false")
  el-row
    el-col(:span="24")
      el-card.card-info(:body-style="{ width: '100%' }" shadow="hover")
          el-row.cardList(:span="24")
            el-col.flex.padding(:span="18")
              div.cardList
                el-col.labelDiv(:span="12")
                  b Número do processo:
                  | {{" " + numeroProcesso }}
                el-col(:span="12")
                  b Tipo:
                  | {{ " " + this.tipoProcesso }}
                el-col(:span="12")
                  b Status:
                  | {{ " " + statusProcesso(this.processo && this.processo.status ? this.processo : '-' ) }}
                el-col.labelDiv(:span="12")
                  b Setor:
                  | {{ " " + this.setorFormatadoProceso(this.setor, this.processo.perfil, this.status)}}
            el-col(:span="6")
              div.flexEndButton
                el-button.green.textButtonBreak(
                  v-if="isDeclaracaoVisible"
                  tipo="success",
                  @click="goTo()"
                )
                  span.center
                    i.fal.fa-file-download
                    | &nbsp Declaração de trâmite processual

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppButton from '../../../components/AppButton'
import GerarDeclaracaoTramite from '@/screens/central/components/GerarDeclaracaoTramite'
const {setStatus, setSetor} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  components: {
    AppButton,
    GerarDeclaracaoTramite
  },

  data () {
    return {
      showDialog: false,
      showModalDeclaracao: false
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    detalhesProcesso () {
      return [{
        tipo: this.tipoProcesso,
        status: this.status,
        setor: this.setor
      }]
    },

    isDeclaracaoVisible () {
      return (this.status === 'AGUARDANDO_ANALISE' || this.status === 'EM_ANALISE' || this.statusProcesso(this.status) === 'Em análise' || this.statusProcesso(this.status) === 'Aguardando análise') && (this.tipoProcesso === 'Não Oneroso' || this.tipoProcesso === 'Oneroso' || this.tipoProcesso === 'TQ')
    },

    processo: {
      get () {
        return this.$store.getters['processos/processo']
      }
    },

    numeroProcesso: {
      get () {
        if (this.processo && this.processo.numeroProcesso) {
          return this.processo.numeroProcesso
        }
        return '-'
      }
    },

    setor: {
      get () {
        if (this.processo && this.processo.setor) {
          return this.processo.setor
        }
        return '-'
      }
    },

    status: {
      get () {
        if (this.processo && this.processo.status) {
          return this.processo.status
        }
        return '-'
      }
    },
    tipoProcesso: {
      get () {
        if (this.processo && this.processo.tipo && this.processo.tipo.nome) {
          return this.processo.tipo.nome
        }
        return '-'
      }
    }
  },

  methods: {
    ...mapActions({
      setVisible: 'dialog/setVisible'
    }),
    statusProcesso (prop) {
      return setStatus(prop)
    },
    setorFormatadoProceso (prop, perfil, status) {
      if (perfil === 'TECNICO_DE_CAMPO') return `Técnico de campo`

      if (status === 'AGUARDANDO_RESPOSTA_INTERESSADO') {
        return 'Aguardando resposta do interessado'
      }

      if (status === 'AGUARDANDO_ANALISE_VISTORIA_REMOTA') {
        return 'Aguardando vistoria remota'
      }

      if (prop === 'GP' && status?.includes('ASSINATURA')) {
        return 'Gabinete da Presidência - GP - Assinatura'
      }

      if (process.env.ESTADO !== 'ma') {
        return this.setor === 'SISTEMA' ? 'Aguardando geração de documentos pelo sistema' : setSetor(prop) + ' - ' + setoresFormatado[this.setor]
      } else {
        return this.setor
      }
    },
    openDialog () {
      this.setVisible(true)
    },
    goTo () {
      this.showModalDeclaracao = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    text-align: left;
    float: left;
  }
  .numero-processo {
      font-weight: bold;
      font-size: 18px;
  }
  .prazo-atendimento {
      font-weight: bold;
  }

  .link-voltar {
    font-size: 18px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    cursor: pointer;
    text-decoration: underline;
  }

  .link-voltar :hover {
    color:#1AB182 ;
    text-decoration-color: #1AB182;
  }
  .component {
    .text-btn {
      color: #575757;
      padding: 0;
    }

    .center {
      display: flex;
      align-items: center;
    }

    .text {
      color: #575757;
      padding: 0;
    }

    .header {
      text-align: center;
    }
  }
  .el-table__body {
    td {
      background-color: #fff;
    }
  }
  .el-table__body tr.current-row > td {
    background-color: #fff;
  }
  .green {
    color: #FFFFFF;
    background-color: #009F61;
  }
  .titulo {
    font-size: 16px;
  }
  .card-info {
  border-radius: 15px;
  background-color: #f3f7fa;
  border-color: #eaeef1;
  margin: 2%;
 }
 .el-col {
  margin-bottom: 10px;
 }
 .flex {
   display: flex;
 }
 .padding {
  margin-top: 9px;
  }
 .flexEndButton {
    display: flex;
    justify-content: flex-end;
    align-content: center;
    white-space: break-spaces
}

.marginButton {
  margin-top: 15px;
}

.textButtonBreak {
  white-space: break-spaces;
}

.breakText {
  word-break: break-all;
}

@media (max-width: 780px) {

  .cardList {
    display: flex;
    flex-direction: column;
  }

  .labelDiv {
    width: 270px;
  }

  .flexEndButton {
    width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/processos/CabecalhoProcesso.vue